/**
 * Configuration file for API connections and environment variables
 */

// Google OAuth Client ID (requerido en build/deploy)
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// Base URL para la API
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL 



// API Key común para todas las peticiones (Flows API + Labs API)
export const API_KEY = process.env.REACT_APP_API_KEY || process.env.REACT_APP_LABS_API_KEY || '';

// Headers comunes para todas las peticiones
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'accept': 'application/json',
  'x-api-key': API_KEY,
};

export function assertApiKeyConfigured() {
  if (!API_KEY) {
    throw new Error(
      'REACT_APP_API_KEY no está en el bundle desplegado. En Amplify: verifica la variable, haz "Clear cache and deploy" en la rama develop, y confirma que App root = xl-frontend-flows.'
    );
  }
}

export function normalizeUserEmail(email) {
  return (email || '').trim().toLowerCase();
}

/** Allowlist fija de dominios Workspace autorizados (no ampliable por env en cliente). */
export const ALLOWED_DOMAINS = Object.freeze(['xinerlink.cl', 'valorate.cl']);

const DOMAIN_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/;

const DOMAIN_MARKS = {
  'xinerlink.cl': 'ˣ',
  'valorate.cl': 'ᵛ',
};

export function getEmailDomain(email) {
  if (!email || !email.includes('@')) return '';
  return email.split('@')[1].trim().toLowerCase();
}

/** Marca tipográfica chica: ˣ (xinerlink) / ᵛ (valorate) */
export function getEmailDomainMark(email) {
  return DOMAIN_MARKS[getEmailDomain(email)] || '';
}

/**
 * Valida cuenta Workspace: email y hd deben pertenecer a ALLOWED_DOMAINS.
 * Requiere ambos checks (email + hosted domain) para evitar cuentas personales.
 */
export function isAuthorizedGoogleAccount(hd, email) {
  const hostedDomain = (hd || '').trim().toLowerCase();
  const normalizedEmail = normalizeUserEmail(email);
  const emailDomain = getEmailDomain(normalizedEmail);

  if (!emailDomain || !DOMAIN_PATTERN.test(emailDomain)) {
    return false;
  }
  if (!ALLOWED_DOMAINS.includes(emailDomain)) {
    return false;
  }
  if (!hostedDomain || !DOMAIN_PATTERN.test(hostedDomain)) {
    return false;
  }
  if (!ALLOWED_DOMAINS.includes(hostedDomain)) {
    return false;
  }
  if (!normalizedEmail.endsWith(`@${emailDomain}`)) {
    return false;
  }
  return true;
}

// Debug mode - set to false to disable most console logs
export const DEBUG = process.env.REACT_APP_DEBUG === 'true' || false;

// Environment identifier
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT 

// Log deduplication timeout
export const LOG_DEDUP_TIMEOUT = 3000; // 3 seconds

// Labs API URL
export const LABS_API_URL = process.env.REACT_APP_LABS_API_URL 